import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import Auxiliary from "util/Auxiliary";
import ModuleBreadcrumb from "components/Common/ModuleBreadcrumb";
import { Col, Row, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getAttendanceDataSelector,
  getTotalUsers,
} from "../../../appRedux/selectors/User";
import {
  requestAttendanceGet,
  requestUserDetails,
} from "../../../appRedux/actions/User";
import { useParams } from "react-router-dom";
import AttendanceViewCard from "./AttendanceViewCard";

const AttendanceDetails = () => {
  const AttDetails = useSelector(getAttendanceDataSelector);
  const total = useSelector(getTotalUsers);
  const params = useParams();
  const dispatch = useDispatch();

  const attendanceData = useMemo(() => {
    if (AttDetails && AttDetails?.users?.length) {
      return AttDetails?.users.map((a, i) => {
        return {
          ...a,
          key: i + 1,
        };
      });
    }
    return [];
  }, [AttDetails]);

  const initialParams = useMemo(() => {
    return {
      page: 1,
      limit: 10,
      q: "",
    };
  }, []);

  useEffect(() => {
    dispatch(requestAttendanceGet({ id: params.id, date: "" }));
    dispatch(requestUserDetails(initialParams));
  }, [initialParams]);

  const columns = [
    {
      title: "No",
      dataIndex: "key",
      width: 60,
    },
    {
      title: "Name",
      dataIndex: "user_name",
      width: 300,
    },
    {
      title: "Phone No",
      dataIndex: "mobile",
      width: 150,
    },
    {
      title: "Address",
      dataIndex: "address",
    },
  ];

  return (
    <AttendanceDetailStyle>
      <Auxiliary>
        <ModuleBreadcrumb
          title="Nikol Bal-Sabha Attendance"
          breadcrumbs={["Attendance", "View"]}
          links={["/attendance", "/attendance", ""]}
        />
        <Row className="gx-profile-content">
          <Col span={24}>
            <div className="gx-card">
              <div className="gx-card-body">
                <AttendanceViewCard data={AttDetails} total={total} />
                <Table
                  columns={columns}
                  dataSource={attendanceData}
                  scroll={{
                    y: 400,
                    x: 1000,
                  }}
                  pagination={false}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Auxiliary>
    </AttendanceDetailStyle>
  );
};

const AttendanceDetailStyle = styled.div``;

export default AttendanceDetails;
